import { DialogTitle, InputBase, Chip } from "@mui/material";
import { green, grey, red } from "@mui/material/colors";
import { Theme } from "@mui/material/styles";

import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

const styles = makeStyles((theme: Theme) => ({
  rootDialog: {
    fontFamily: "Poppins !important",
    "& .MuiBackdrop-root": {
      backgroundColor: "none !important",
    },
  },
  dialogHeader: {
    backgroundColor: "#308CDB",
  },
  titleHeader: {
    fontFamily: "Poppins !important",
    backgroundColor: "#308CDB",
    fontSize: "16px",
    fontWeight: 700,
  },
  chipInfo: {
    margin: theme.spacing(0.2),
  },
  addContactsIcon: {
    width: 30,
    height: 30,
    color: green[700],
  },
  bxRoot: {
    "& .MuiTypography-root": {
      width: "100%",
      color: red[800],
    },
  },
  bxRecipients: {
    boxSizing: "border-box",
    padding: 10,
    border: `1px solid ${grey[500]}`,
  },
  bxMessageWrap: {
    margin: "10px auto",
    border: `1px solid ${grey[500]}`,
    "& .jodit-status-bar-link": {
      display: "none",
    },
  },
  bxProgressWrap: {
    "& .MuiCircularProgress-root": {
      display: "block",
      margin: "auto",
    },
    "& span": {
      fontFamily: "Poppins",
    },
  },
  errorMessage: {
    color: red[800],
  },
  closeButton: {
    color: grey[50],
  },
  jsonBox: {
    height: "calc(100vh - 575px)",
  },
  attachmentBadge: {
    backgroundColor: "#EDF5FB !important",
    color: "#3F6280  !important",
    "& span": {
      fontWeight: 700,
      fontSize: "12px",
    },
  },
  inputLabel: {
    color: "#308CDB",
    fontWeight: 600,
    fontSize: "14px",
    fontFamily: "Manrope",
    marginTop: "24px",
    lineHeight: "24px",
  },
}));

// Toolbar::: Custom -- Dialog Title Component
export const DialogTitleToolbar = withStyles(() => ({
  root: {
    color: grey[50],
    backgroundColor: "#498CD5",
    height: 48,
    padding: "0px 10px",
    "& span": {
      fontWeight: "bold",
    },
  },
}))(DialogTitle);

// InputBase::: Custom -- Text Email
export const TxtEmails = withStyles(() => ({
  root: {
    minWidth: 400,
    fontFamily: "Poppins",
  },
}))(InputBase);

// InputBase::: Custom -- Text Message Body
export const TxtMessage = withStyles(() => ({
  root: {
    border: `1px solid ${grey[500]}`,
    padding: 10,
    marginTop: 30,
  },
}))(InputBase);

// Chip::: Custom -- Email Info Wrapper
export const EmailInfoWrapper = withStyles(() => ({
  root: {
    background: "#69CCC3",
  },
}))(Chip);

// Chip::: Custom -- Attachment Wrapper
export const AttachmentWrapper = withStyles((theme: Theme) => ({
  root: {
    background: "#38CFC4",
    color: "#FFF",
    padding: "4px 8px",
    borderRadius: "20px",
    margin: theme.spacing(0.5),
    "& svg": {
      color: "#FFF",
      width: "13px",
      height: "13px",
    },
    "& span": {
      fontFamily: "Manrope",
      fontWeight: 600,
      fontSize: "12px",
    },
  },
}))(Chip);

export default styles;
